module.exports = __webpack_public_path__ + "static/media/10-Diamond.e900317e.svg";